import { apiPrefixes } from '@/api/apiPrefixes'
import { httpWithCookie, ResultType, toLogin } from '@/utils'
import { CandidateMember } from '@/interfaces'

const api = {
  queryCandidatesList: `${apiPrefixes.ehrapi}/api/rkhy/interviewManage/getCandidatesList.do`
}

const queryCandidatesList = async ({
  tabType,
  status,
  startTime,
  endTime,
  type,
  pageIndex,
  pageSize,
  name
}: any = {}): Promise<CandidateMember[] | null> => {
  const params = {
    tabType,
    status,
    startTime,
    endTime,
    type,
    pageIndex,
    pageSize,
    name
  }

  try {
    const result = await httpWithCookie.post<
      any,
      ResultType<{ list: CandidateMember[] }>
    >(api.queryCandidatesList, params)

    const { code, data } = result
    if (+code == 1) {
      return data?.list || null
    } else if (+code == 1024) {
      toLogin()
      return null
    } else {
      return null
    }
  } catch (e) {
    console.error(e)
    if (typeof e == 'string') {
      throw e
    }
    throw '网络异常'
  }
}

export const ehr = {
  queryCandidatesList
}
